import styled, { DefaultTheme, ThemedCssFunction, css, keyframes } from 'styled-components'
import { Text, theme } from 'yolda-web-ui'
import { InfoAlignType, InfoType } from './AbsoluteInfo'

const backgroundColors = {
  error: '#FFEBEA',
  default: theme.colors.black[300],
  warning: '',
}

const arrowUpCss = (infoType?: InfoType) => css`
  position: absolute;
  right: 0;
  top: -12px;
  margin-right: 62px;
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid ${backgroundColors[infoType || 'default']};
`

const arrowUpBorderCss = css`
  position: absolute;
  right: 0;
  top: -10px;
  margin-right: 63px;
  width: 0;
  height: 0;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-bottom: 11px solid ${theme.colors.white[500]};
`

const arrowLeftCss = (infoType?: InfoType) => css`
  position: absolute;
  left: -0.6rem;
  top: 0;
  margin-top: 2.1rem;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid ${backgroundColors[infoType || 'default']};
`

const arrowLeftBorderCss = css`
  position: absolute;
  left: -0.5rem;
  top: 0;
  margin-top: 2.16rem;
  width: 0;
  height: 0;
  border-top: 9px solid transparent;
  border-bottom: 9px solid transparent;
  border-right: 9px solid ${theme.colors.white[500]};
`

const infoTextPropsByType: any = {
  error: `
    color: #F50100;
    font-weight: ${theme.fontWeight.medium};
  `,
  warning: ``,
}

const infoWrapperPropsByType: Record<InfoType, any> = {
  error: (props: { show: boolean; align?: InfoAlignType; infoType?: InfoType }) => css`
    z-index: 4;
    left: 100%;
    top: -1rem;
    margin-left: ${theme.spacing.medium};
    background-color: ${backgroundColors[props?.infoType || 'default']};
    padding: ${theme.spacing.medium};
    border-radius: ${theme.radius.medium};
    &:before,
    &:after {
      content: '';
    }

    @media screen and (min-width: 72rem) {
      &:before {
        ${arrowLeftCss(props.infoType)};
      }
    }

    @media screen and (max-width: 72rem) {
      margin-left: unset;
      left: unset;
      right: 0;
      top: 100%;
      margin-top: ${theme.spacing.medium};

      &:before {
        ${arrowUpCss(props.infoType)};
      }
    }
  `,
  warning: () => css``,
  default: () => css`
    z-index: 4;
    left: 100%;
    top: -1rem;
    margin-left: ${theme.spacing.medium};
    background-color: ${theme.colors.white[500]};
    padding: ${theme.spacing.default};
    border-radius: ${theme.radius.normal};
    border: 1px solid ${theme.colors.black[300]};

    &:before,
    &:after {
      content: '';
    }

    @media screen and (min-width: 72rem) {
      &:before {
        ${arrowLeftCss()};
      }

      &:after {
        ${arrowLeftBorderCss};
      }
    }

    @media screen and (max-width: 72rem) {
      margin-left: unset;
      left: unset;
      right: -20px;
      top: 100%;
      margin-top: ${theme.spacing.medium};

      &:before {
        ${arrowUpCss()};
      }

      &:after {
        ${arrowUpBorderCss};
      }
    }
  `,
}

export const AbsoluteInfoWrapper = styled.div<{ show: boolean; align?: InfoAlignType; infoType?: InfoType }>`
  ${(props: { show: boolean; align?: InfoAlignType; infoType?: InfoType }) =>
    infoWrapperPropsByType?.[props?.infoType || 'default']?.(props)}
  position: absolute;
  display: ${props => (props?.show ? 'flex' : 'none')};
  min-width: 250px;

  @media screen and (max-width: 72rem) {
    max-width: 25rem;
  }
`

export const CloseButton = styled.button`
  display: flex;
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: inherit;
  font: inherit;
  border-radius: 0;
  appearance: none;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  text-align: start;
  margin-right: 0.5rem;
`

export const InfoText = styled(Text)<{ infoType?: InfoType; bold?: boolean }>`
  ${props =>
    props?.infoType &&
    css`
      ${infoTextPropsByType[props?.infoType]}
    `}
  ${props =>
    props?.bold &&
    css`
      font-weight: 500;
    `}

    line-height: ${theme.font.large};
`

export const CloseButtonWrapper = styled.div``
